<body class="main">
  <header>
    <img src="/LogoFrigelar.svg" width="250px" style="padding: 20px;" />
  </header>
  <main>
    <h3>Aviso importante!</h3>
    <br>
    <p>Não conseguimos redireciona-lo para o aplicativo.</p>
  </main>
  <footer>
    <div>
      Frigelar Comércio e Indústria Ltda. – CNPJ 92.660.406/0001-19 – Av. Pernambuco, 2285, Navegantes, CEP
      90240-005, Porto Alegre/RS. Todas as políticas, preços e condições são validos apenas para compras
      realizadas via APP, nesta data e enquanto durar o estoque. Vendas sujeitas à análise e confirmação de dados.
      As ofertas podem ser retiradas do APP quando os produtos em estoque estiverem esgotados e não for possível
      efetuar a reposição com os fornecedores. Todos os direitos reservados. Imagens meramente ilustrativas.
    </div>
  </footer>
</body>
